import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiArrowUpRight } from 'react-icons/fi';
import { servicesData } from './serviceMetaData';
import VoicesInteriorScene, { interiorSceneType } from '../voices/VoicesInteriorScene';
import './css/VoicesServiceDetail.css';

export default function ServicedDetailBanner({ serviceTitle, serviveLogo, serviceName }) {
  const service = servicesData.find(item => item.name === serviceName);
  const isSalesforce = serviceName?.startsWith('Salesforce ');

  return <VoicesInteriorScene as="header" className="v-service-detail-hero" data-voices-theme="dark" id="about" scene={interiorSceneType(service)}>
    <div className="v-service-detail-copy">
      <Link to="/services" className="v-service-detail-back"><FiArrowLeft aria-hidden="true" /> All services</Link>
      <div className="v-service-detail-category">
        {serviveLogo && <img src={serviveLogo} alt="" width="80" height="36" decoding="async" />}
        <p>{service?.category || 'Services'} / {serviceName}</p>
      </div>
      <h1 className="v-service-detail-title">{isSalesforce ? <>Salesforce{' '}<br /><em>{serviceName.slice(11)}</em></> : serviceName}</h1>
      {serviceTitle && <p className="v-service-detail-summary">{serviceTitle}</p>}
      <Link className="v-service-detail-contact" to="/contact">Discuss your project <FiArrowUpRight aria-hidden="true" /></Link>
    </div>
  </VoicesInteriorScene>;
}
